import { Permission } from '@amzn/coral_com-amazon-passportaccessmanagementcore';

export const AUTHORIZATION = {
  ADMIN: Permission.ADMIN,
  ACCESS: Permission.ACCESS,
};

export const AUTHORIZED_LP_FOR_SP_PERFORMANCE = 'amzn1.pa.o.A2ST90WUWNWT4B';

export const AUTHORIZED_LP_FOR_SP_PERFORMANCE_BETA =
  'amzn1.pa.o.A3GC6VBS8FRKVN';
